import api from './AxiosInstance';


export class UtilisateurService {

  getUserRoles = async () => {
    try {
      const response = await api.get(`/User/Role/list`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getUserPrivileges = async (role_code) => {
    try {
      const response = await api.get(`/User/Privileges/list?role=${role_code}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  updateUserPrivileges = async (payload) => {
    try {
      const response = await api.put(`/User/updateUserPrivileges`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };


  getAllUtilisateur = async () => {
    try {
      const response = await api.get(`/User/list/IPM`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };


  addUser = async (payload) => {
    try {
      const response = await api.post(`/User/add`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  updateUser = async (payload) => {
    try {
      const response = await api.put(`/User/update/${payload.username}`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  updatePasswordUserName = async (login, payload,) => {
    try {
      const response = await api.put(`/User/update/${login}`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  updatePasswordConnect = async (payload) => {
    try {
      const response = await api.put(`/User/updatePassword`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  updatePassword = async (payload) => {
    try {
      const response = await api.put(`/User/updatePasswordAdmin`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  deleteUser = async (login) => {
    try {
      const response = await api.delete(`/User/delete/${login}/dev1`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };


}